<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>
      </div>

      <div class="content-container">
        <div class="actions-row">
          <p-button
            [icon]="
              'pi pi-refresh' +
              (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
            "
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="refreshData()"
          />

          <!-- <p-button
            icon="pi pi-filter"
            severity="info"
            [outlined]="!filtersDialogVisible"
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="toggleFilters()"
            [label]="appliedFiltersCount"
          /> -->

          <input
            #dataSearch
            type="text"
            pInputText
            id="search-input"
            (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
            [placeholder]="t(SEARCH_PLACEHOLDER)"
            class="search-input"
          />

          <!-- <p-button
            icon="pi pi-list-check"
            severity="secondary"
            [disabled]="selectedRows.length === 0"
            (click)="batchMenuElement.toggle($event)"
          />

          <p-menu
            #batchMenuElement
            [model]="batchMenu"
            [popup]="true"
            appendTo="body"
          /> -->
        </div>

        <p-skeleton
          class="skeleton-loader"
          height="100%"
          width="100%"
          [class.visible]="(dataLoadingUI$ | async) ?? true"
        />

        <p-table
          #dataTable
          class="table"
          id="table"
          [value]="data"
          [(selection)]="selectedRows"
          [rowHover]="true"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
          sortMode="single"
          selectionMode="multiple"
          [rowTrackBy]="_dataTrackBy"
          [metaKeySelection]="true"
          [resizableColumns]="true"
          columnResizeMode="fit"
          [globalFilterFields]="dataFilterFields"
          stripedRows
          [scrollable]="true"
          [class.visible]="!((dataLoadingUI$ | async) ?? true)"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <th [pSortableColumn]="col.field" pResizableColumn>
                    <div class="table-header-row">
                      <span class="header-label">{{
                        t(col.header, col.headerParams)
                      }}</span>
                      <div class="header-buttons">
                        <p-sortIcon [field]="col.field" />
                      </div>
                    </div>
                  </th>
                }
              }
            </tr>
          </ng-template>
          <ng-template #body let-record let-rowIndex="rowIndex">
            <tr
              [pSelectableRow]="record"
              [pSelectableRowIndex]="rowIndex"
              (contextmenu)="$event.preventDefault(); openFormDialog(record)"
              (longPress)="openFormDialog(record)"
              appLongPress
            >
              <td (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="record" />
              </td>
              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <td>
                    <!-- CELLA -->
                    @if (col.wrapper) {
                      <ng-container
                        *ngComponentOutlet="
                          col.wrapper;
                          inputs: parseWrapperInputs(col, [
                            record,
                            getCellData(col, record),
                          ])
                        "
                      ></ng-container>
                    } @else {
                      <span [innerHTML]="getCellData(col, record)"></span>
                    }
                  </td>
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="t(EDIT_RECORD_TITLE, { username: formDialogData.username })"
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="dialogForm.reset(formDialogData)"
  >
    <form class="dialog-form" #dialogForm="ngForm">
      <!--? USERNAME ----------------------------->
      <p-floatlabel variant="in">
        <input
          pInputText
          id="user-username-input"
          [value]="formDialogData.username"
          [disabled]="true"
        />
        <label for="user-username-input">
          {{ t("username") }}
        </label>
      </p-floatlabel>

      <!--? EMAIL ----------------------------->
      <p-floatlabel variant="in">
        <input
          #userEmailInput="ngModel"
          pInputText
          id="user-email-input"
          name="email"
          [(ngModel)]="formDialogData.email"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          required
        />
        <label for="user-email-input">
          {{ t("email") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? FIRSTNAME ----------------------------->
      <p-floatlabel variant="in">
        <input
          pInputText
          id="user-firstName-input"
          [value]="formDialogData.firstName"
          [disabled]="true"
        />
        <label for="user-firstName-input">
          {{ t("firstName") }}
        </label>
      </p-floatlabel>

      <!--? LASTNAME ----------------------------->
      <p-floatlabel variant="in">
        <input
          pInputText
          id="user-lastName-input"
          [value]="formDialogData.lastName"
          [disabled]="true"
        />
        <label for="user-lastName-input">
          {{ t("lastName") }}
        </label>
      </p-floatlabel>

      <!--? GENDER ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          inputId="user-gender-input"
          [ngModel]="formDialogData.gender"
          autocomplete="off"
          [disabled]="true"
          appendTo="body"
          [options]="[
            { label: t('male'), value: 'M' },
            { label: t('female'), value: 'F' },
            { label: t('otherOrUnspecified'), value: 'O' },
          ]"
          [ngModelOptions]="{ standalone: true }"
          styleClass="w-full"
        />
        <label for="user-gender-input">
          {{ t("gender") }}
        </label>
      </p-floatlabel>

      <!--? BIRTH ----------------------------->
      <p-floatlabel variant="in">
        <p-datepicker
          inputId="user-birthDate-input"
          appendTo="body"
          [ngModel]="formDialogData.birthDate"
          showIcon
          iconDisplay="input"
          [disabled]="true"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="user-birthDate-input">
          {{ t("birthDate") }}
        </label>
      </p-floatlabel>

      <!--? ACTIVE ---------------------------------->
      <div class="select-button-float-label">
        <p-selectbutton
          #userActiveInput="ngModel"
          inputId="user-active-input"
          name="active"
          [(ngModel)]="formDialogData.active"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('active'), value: true },
            { label: t('notActive'), value: false },
          ]"
          [allowEmpty]="false"
          required
        />
        <label for="user-active-input">
          {{ t("active") }}
          <span class="mandatory-label">*</span>
        </label>
      </div>

      <!--? EMAIL VERIFIED ---------------------------------->
      <div class="select-button-float-label">
        <p-selectbutton
          #userEmailVerifiedInput="ngModel"
          inputId="user-emailVerified-input"
          name="emailVerified"
          [(ngModel)]="formDialogData.emailVerified"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('yes'), value: true },
            { label: t('no'), value: false },
          ]"
          [allowEmpty]="false"
          required
        />
        <label for="user-emailVerified-input">
          {{ t("emailVerified") }}
          <span class="mandatory-label">*</span>
        </label>
      </div>

      <!--? CREATION ----------------------------->
      <p-floatlabel variant="in">
        <p-datepicker
          inputId="user-creation-input"
          appendTo="body"
          [ngModel]="formDialogData.creation"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [disabled]="true"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="user-creation-input">
          {{ t("creation") }}
        </label>
      </p-floatlabel>

      <!--? LAST LOGIN ----------------------------->
      <p-floatlabel variant="in">
        <p-datepicker
          inputId="user-lastLogin-input"
          appendTo="body"
          [ngModel]="formDialogData.lastLogin"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [disabled]="true"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="user-lastLogin-input">
          {{ t("lastLogin") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog()"
        [outlined]="true"
      />
      <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord()"
        [disabled]="((dataLoading$ | async) ?? true) || !dialogForm.valid"
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <!--<p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm"></form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters.values = {}; refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>-->
</ng-container>
